import N8nFormInput from './FormInput.vue';

export default N8nFormInput;
